/**
 * The capability inventory the permissions matrix renders.
 *
 * The catalogue itself lives in shared/capabilities.json so the Python server
 * resolves the same defaults this screen displays. Role sets there are the
 * target model, not what the code enforces today.
 */

import catalog from '../../../../shared/capabilities.json'
import type { Capability } from './types'

export const CAPABILITIES = catalog.capabilities as Capability[]

/** Sections in the order the sidebar presents them. */
export const SECTION_ORDER: readonly string[] = catalog.sectionOrder
